import React, { useMemo } from "react";
import "./predictionOutput.css";
//how do i import the js?

function PredictionOutput({ response }) {
  //   useEffect(() => {
  //     console.log("This prints out the response whenever the value changes");
  //     console.log(response);
  //   }, [response]);

  const isLowConfidence = response?.certainty < 0.5;

  const backgroundColor = useMemo(() => {
    console.log(response);
    if (isLowConfidence) {
      return "#808080"; // Grey for unable to determine
    }
    const firstFourLetters = response?.result.substring(0, 4).toLowerCase();
    if (response?.certainty < 0.8) {
      return "#ffd900";
    } else if (firstFourLetters === "fake") {
      return "#ff0000"; // Red background color
    } else if (firstFourLetters === "real") {
      return "#008000"; // Blue background color
    }
  }, [response, isLowConfidence]);

  const certaintyPercent = response?.certainty
    ? Math.round(response?.certainty * 10000) / 100
    : null;

  return (
    <div
      className="upload-prediction-root"
      style={{ backgroundColor: backgroundColor }}
    >
      <p>
        <span className="upload-prediction-result-text">Prediction: </span>
        {isLowConfidence ? (
          <span>
            Unable to determine — confidence too low (
            {certaintyPercent !== null ? `${certaintyPercent}%` : "N/A"})
          </span>
        ) : (
          <>
            <span>
              {response?.result} (
              {certaintyPercent !== null ? certaintyPercent : "N/A"}%
            </span>
            <span> Certainty</span>)
          </>
        )}
      </p>
    </div>
  );
}

// const firstFourLetters = response?.substring(0,4).toLowerCase();
// if (firstFourLetters === "fake") {
//   flexbox.style.backgroundColor = "ff0000";
// }
//80+ green, below 80 yellow, algorithym yellow and put a link to the website and 80+ fake red, not a label yellow
export default PredictionOutput;
